const Nav = (props: any) => {
  return (
    <nav style={{ zIndex: 9999 }} className="ct-bg-black ct-w-full ct-flex ct-space-x-2 ct-items-center ct-h-10 ct-px-3 ct-fixed ct-top-0">
      <img width="220" src="versant_white_logo.png"/>
      { props.children }
    </nav>
  )
}

export default Nav;